import { Redirect, RouteComponentProps } from 'react-router-dom';

/* Constants */
import { LANDING_PAGE_ROUTE } from 'constants/RouteConstants';

type PropsType = RouteComponentProps;

const NoMatchRedirect = ({ location }: PropsType) => {
  const { search, hash } = location;

  return (
    <Redirect
      to={{
        pathname: LANDING_PAGE_ROUTE,
        search,
        hash,
      }}
    />
  );
};

export default NoMatchRedirect;
